import { Directive, HostListener, Input, inject } from '@angular/core';
import { ToastService } from 'taxtank-core';
import { Clipboard } from '@angular/cdk/clipboard';

/**
 * Copy provided content to clipboard.
 * Directive can be placed on any element and will copy the data by click on it
 */
@Directive({
  selector: '[appCopyToClipboard]',
  standalone: false
})
export class CopyToClipboardDirective {
  private clipboard = inject(Clipboard);
  private toastService = inject(ToastService);

  @Input('appCopyToClipboard') content: string | number;

  

  @HostListener('click') onClick(): void {
    this.content = this.content.toString();

    this.clipboard.copy(this.content);
    this.toastService.success('Copied to clipboard');
  }
}
